export class PurchaseLogsSearchParams {
  consultantId: number = 0;
  fromDate: Date = null;
  toDate: Date = null;
}

